import { client } from "../src/sanityClient"

export async function getText() {
  return client.fetch(`
    *[_type == "headers"][0]
  `)
}